import classNames from 'classnames';
import View from '../View';
import Txt from '../Txt';
import Input from '../Input';
import Select from '../Select';
import styles from './LabeledInput.module.scss';

/**
 * LabeledInput
 *
 * @return {JSX.Element}
 */
const LabeledInput = ({
  className,
  label,
  select,
  error,
  children,
  noMargin,
  ...rest
}) => {
  return (
    <View
      className={classNames(
        styles.LabeledInput,
        noMargin && styles.LabeledInput__noMargin,
        className,
        `${LabeledInput.displayName}`
      )}
    >
      <View className={styles.Header}>
        <Txt xx bold>
          {label}
        </Txt>
      </View>
      <View className={styles.Body}>
        {children ? (
          children
        ) : select ? (
          <Select fullWidth {...rest} />
        ) : (
          <Input fullWidth {...rest} error={error} />
        )}
      </View>
      {error ? (
        <View className={styles.Footer}>
          <Txt error>{error}</Txt>
        </View>
      ) : null}
    </View>
  );
};

LabeledInput.displayName = 'LabeledInput';

export default LabeledInput;
